/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_Refer_SupervisorInputs */



/**
* | output |
* | --- |
* | "Refer to Supervisor" |
*
* @param {Work_Order_Publish_Option_Refer_SupervisorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_refer_supervisor = /** @type {((inputs?: Work_Order_Publish_Option_Refer_SupervisorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_Refer_SupervisorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transmettre au superviseur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenden Sie sich an den Vorgesetzten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rivolgersi al supervisore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратитесь к руководителю.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Consulte al supervisor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请咨询主管")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スーパーバイザーに問い合わせる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पर्यवेक्षक से संपर्क करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Consulte o supervisor.")
	return /** @type {LocalizedString} */ ("Refer to Supervisor")
});